import routes from './routing';

export const CheckoutRoutes = routes;
